<nz-sider
  nzCollapsible="true"
  [nzWidth]="isMenuCollapsed && !isMobileView ? 80 : 120"
  [nzCollapsible]="!is4Mobile"
  [(nzCollapsed)]="isMenuCollapsed"
  (nzCollapsedChange)="onCollapse($event)"
  [ngClass]="{
  menu: true,
  dark: true,
  unfixed: false
}">
<!--  [(nzCollapsed)]="isMenuCollapsed && !is4Mobile"-->
  <div style="position: relative">
    <div
      class="menuOuter"
      [ngStyle]="{
        width: isMenuCollapsed && !isMobileView ? '80px' : '120px',
        height: isMobileView || isMenuUnfixed ? 'calc(100% - 108px)' : 'calc(100% - 254px)'
      }">
      <div class="logoContainer">
        <div class="logo">
          <img [src]="'./assets/images/logo/logo.svg'" alt="{{ logo }}" />
        </div>
      </div>
      <ng-scrollbar>
        <ul class="navigation">
          <ng-container *ngTemplateOutlet="menuTpl; context: {$implicit: menuDataActivated, level: 0}"></ng-container>
          <ng-template #menuTpl let-menuDataActivated let-level="level">
            <ng-container *ngFor="let item of menuDataActivated">

              <ng-container *ngIf="hasAccess(item); else disabledLink">
                <li class="ant-menu-item ng-star-inserted" routerLinkActive="ant-menu-item-selected">
                  <a routerLink={{item.url}} title="{{item.title}}">
                    <span class="icon-x">
                      <i *ngIf="item.icon" [ngClass]="[item.icon, 'icon']"></i>
                      <img *ngIf="item.svg" [src]="item.svg" alt="{{item.title}}" [ngClass]="[item.ico_class, 'icon']"/>
                    </span>
                    <span class="title">{{ item.title }}</span>
                  </a>
                </li>
              </ng-container>
              <ng-template #disabledLink>
                <li class="ant-menu-item ng-star-inserted">
                  <a title="{{item.title}}" class="disabled">
                    <span class="icon-x">
                      <i *ngIf="item.icon" [ngClass]="[item.icon, 'icon']"></i>
                      <img *ngIf="item.svg" [src]="item.svg" alt="{{item.title}}" [ngClass]="[item.ico_class, 'icon']"/>
                    </span>
                    <span class="title">{{ item.title }}</span>
                  </a>
                </li>
              </ng-template>

            </ng-container>
          </ng-template>
        </ul>
      </ng-scrollbar>
    </div>
    <ng-container *ngIf="!is4Mobile">
      <div
        class="text-center bottom-logo-text"
        [ngStyle]="{width: isMenuCollapsed && !isMobileView ? '80px' : leftMenuWidth + 'px'}">
        <span class="logo-under-menu">
          <img [src]="'./assets/images/logo/logo-vertical-text.svg'" alt="{{ logo }}" />
        </span>
      </div>
    </ng-container>
  </div>
</nz-sider>
